import { SafeAreaView, ScrollView, Dimensions, Text } from "react-native";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import {
	routeHome,
	routePayment,
	routeScreenManager,
	PaymentScreenNavigationProp,
	routePlayer,
	routeTrailer,
	routeLogin,
	routePage,
	routeSearchScreen,
	routeDataManagementSettings,
	routeMyLibrary,
	routeAggregatePage,
	routeNewCuration,
	routeVamPlayer,
	routeLegalsScreen,
	routeVamScreenManager,
	routeMobilePayment,
} from "../../Routes";
import { Metadata } from "../../models/Metadata";
import TopAppBar from "../../components/TopAppBar/index";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import TabsView from "../../components/TabsView";
import ViewDetails from "./ViewDetails";
import Details from "./Details";
import GradientLeftSide from "../../components/GradientLayer/GradientLeftSide";
import Image from "../../components/Image/Image";
import TitleDetailsLoader from "../../components/Loaders/TitleDetailsLoader";
import ImgProgressBar from "../../components/Loaders/ImgProgressBar";
import CustomizeDialogBox from "../../components/DialogMessageBox/CustomizeDialogBox";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { redeemProductV8 } from "../../services/purchaseService";
import Toast from "../../components/Toast";
import { AsyncStorageKeys, Pages, direction, PurchaseTransactionType, CarActivity } from "../../Types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import useGenericContentStore from "../../store/genericContent.store";
import Extras from "./Extras";
import { getProgressVideo } from "../../services/progressVideoService";
import { useFocusEffect } from "@react-navigation/core";
import {
	convertDuration,
	convertToLanguage,
	getCurrencySymbol,
	getPreviousRouteName,
	getVideoQualityByDeviceHeight,
	globalAny,
	isCoPassenger,
	isVersionValidForTrailer,
	metadataTextSeparator,
	onCheckingNetwork,
	recordAnalytics,
} from "../../utils/Utils";
import { AppLogger } from "../../utils/AppLogger";
import * as CacheStorageUtils from "../../utils/CacheStorageUtils";
import { purchaseHistory, productPrice } from "../../services/paymentService";
import usePaymentTransactionStore from "../../store/usePaymentTransaction.store";
import { accountCredits, accountCreditsExpiration } from "../../services/accountService";
import { TRANSACTION_TYPES } from "../../networking/networking";
import { getAvailableAudioLanguages, getConcurrency, getPlaybackWindow, postConcurrency } from "../../services/videoService";
import { getTrailer } from "../../services/trailerService";
import CarActivityDialog from "../../components/CarActivityDialog";
import { getAvailability } from "../../services/metadataService";
import { responseOk } from "../../utils/ValidateResponse";
import useDrivingStore from "../../store/useDriving.store";
import useMqttStore from "../../store/useMqtt.store";
import ControllerContent from "../../components/ControllerContent";
import ScreenIcon from "../../assets/ControllerIcon/Screen-Icon.svg";
import ExitPreviewButton from "../../components/ExitPreviewButton";
import { v4 as uuidv4 } from "uuid";
import useSearchDataStore from "../../store/useSearchData.store";
import useToggleStore from "../../store/useToggle.store";
import Marquee from "react-fast-marquee";
import useLegalContentStore from "../../store/useLegalContent.store";
import { metadataContent, metadataContentPreview } from "../../services/movieContentService";
import {
	StyledContainerColumn,
	StyledContainerTdp,
	StyledImage,
	StyledLoading,
	StyledMain,
	StyledTabsContainer,
	TabsContainer,
	StyledPackshot,
	BlurFooter,
	StyledPackshotNarrow,
	StyledMaskGroupNarrow,
	StyledMainNarrow,
} from "./styled";
import { EventType } from "../../enums/EventType";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";

const contentPerRow = 24;
const extrasContentPerRow = 15;

const NewTitleDetails = (props: any) => {
	const navigation = useNavigation<any>();
	const navigationPayment = useNavigation<PaymentScreenNavigationProp>();
	const { isOnline, isOffline } = useNetworkStatus();
	const { route } = props;
	const { parentProductId, preview } = route.params;
	const hasReloaded = useRef(false);
	const [showOnline, setShowOnline] = useState(false);
	const [metadata, setMetadata] = useState<Metadata>();
	const [backgroundImage, setBackgroundImage] = useState("");
	const [ratingReason, setRatingReason] = useState("");
	const [progressBar, setProgressBar] = useState(0);
	const [streamProgress, setStreamProgress] = useState(0);
	const [director, setDirector] = useState([]);
	const [ownProduct, setOwnProduct] = useState(false);
	const [packshot, setPackshot] = useState();
	const [selectedProductRedeemed, setSelectedProductRedeemed] = useState<any>();
	const [showRedeemModal, setShowRedeemModal] = useState(false);
	const [showPurchaseModal, setShowPurchaseModal] = useState(false);
	const [visible, setVisible] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [labelText, setLabelText] = useState("");
	const [type, setType] = useState(ComponentTypeEnum.Secondary);
	const [vamData, setVamData] = useState<any>({});
	const [channelData, setChannelData] = useState([]);
	const [hasCredit, setHasCredit] = useState(false);
	const [showCarToast, setShowCarToast] = useState(false);
	const [expiryDate, setExpiryDate] = useState({});
	const [availabilityRedeem, setAvailabilityRedeem] = useState(false);
	const [availabilityPurchase, setAvailabilityPurchase] = useState(false);
	const [availabilityRent, setAvailabilityRent] = useState(false);
	const [noVamData, setNoVamData] = useState(true);
	const [isProcessing, setIsProcessing] = useState(false);
	const [movieAvailableLang, setMovieAvailableLang] = useState("");
	const [audioLang, setAudioLang] = useState("");
	const [subtitleLang, setSubtitleLang] = useState("");
	const [isTrailer, setIsTrailer] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isExtrasLoading, setIsExtrasLoading] = useState(true);
	const [isCompleteData, setIsCompleteData] = useState(false);
	const [ownedTransaction, setOwnedTransaction] = useState<any>({});
	const NO_IMAGE_RETURNED = "";
	const onDismissSnackBar = () => setVisible(false);
	const selectedTabs = useGenericContentStore((state: any) => state.selectedTabs);
	const setSelectedTabs = useGenericContentStore((state: any) => state.setSelectedTabs);
	const setVamDetails = useGenericContentStore((state: any) => state.setVamDetails);
	const navigateEvent = useGenericContentStore((state: any) => state.navigateEvent);
	const setNavigateEvent = useGenericContentStore((state: any) => state.setNavigateEvent);
	const isSuccess = useGenericContentStore((state: any) => state.isSuccess);
	const dimensions = useGenericContentStore((state: any) => state.dimensions);
	const setIsSuccess = useGenericContentStore((state: any) => state.setIsSuccess);
	const hasRent = usePaymentTransactionStore((state: any) => state.hasRent);
	const setHasRent = usePaymentTransactionStore((state: any) => state.setHasRent);
	const setPurchasePrice = usePaymentTransactionStore((state: any) => state.setPurchasePrice);
	const setRentPrice = usePaymentTransactionStore((state: any) => state.setRentPrice);
	const mistakeCount = useGenericContentStore((state: any) => state.mistakeCount);
	const setMistakeCount = useGenericContentStore((state: any) => state.setMistakeCount);
	const carActivity = useDrivingStore((state: any) => state.carActivity);
	const mqttDevices = useMqttStore((state: any) => state.mqttDevices);
	const setPlaySessionId = useMqttStore((state: any) => state.setPlaySessionId);
	const setCurrencySymbol = usePaymentTransactionStore((state: any) => state.setCurrencySymbol);
	const lastSearchData = useSearchDataStore((state: any) => state.lastSearchData);
	const aggregatePageId = useGenericContentStore((state: any) => state.aggregatePageId);
	const uniqueId = useGenericContentStore((state: any) => state.uniqueId);
	const setIsRenderHome = useGenericContentStore((state: any) => state.setIsRenderHome);
	const isToggleMQTT = useToggleStore((state: any) => state.isToggleMQTT);
	const fetchLegals = useLegalContentStore((state: any) => state.fetchLegals);
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);
	const [textRent, setTextRent] = useState("");
	const [textPurchase, setTextPurchase] = useState("");
	const [windowWidth, setWindowWidth] = useState<any>();
	const [gridSize, setGridSize] = useState<any>(contentPerRow);
	const [extraLoader, setExtraLoader] = useState(false);
	const [next, setNext] = useState(isNarrow ? extrasContentPerRow : contentPerRow);
	const [isLoadingButton, setIsLoadingButton] = useState(true);
	const [isRedeem, setIsRedeem] = useState(false);
	const [isPurchase, setIsPurchase] = useState(false);
	const [isRented, setIsRented] = useState(false);
	const [creditCost, setCreditCost] = useState("");
	const [pauseMarquee, setPauseMarquee] = useState(false);
	const isDefaultTerritory = localStorage.getItem(AsyncStorageKeys.RegionOverride) === "US";
	const isEnableMobilePayment = usePaymentTransactionStore((state: any) => state.isEnableMobilePayment);
	const mobilePaymentTerritories = usePaymentTransactionStore((state: any) => state.mobilePaymentTerritories);
	const setStartPlaying = useGenericContentStore((state: any) => state.setStartPlaying);
	const startPlaying = useGenericContentStore((state: any) => state.startPlaying);
	const isToggleSKLegals = useToggleStore((state: any) => state.isToggleSKLegals);
	const isExtras = useGenericContentStore((state: any) => state.isExtras);
	const setIsExtras = useGenericContentStore((state: any) => state.setIsExtras);
	const isPlayerLoading = useGenericContentStore((state: any) => state.isPlayerLoading);
	const setIsPlayerLoading = useGenericContentStore((state: any) => state.setIsPlayerLoading);

	const controllerData = [
		{ id: 0, icon: ScreenIcon, buttonText: globalAny.language.assign_to_screens, textDescription: globalAny.language.assign_media_to_screen },
		{ id: 1, icon: "", buttonText: globalAny.language.cancel, textDescription: globalAny.language.select_media_to_assign },
	];

	const [controller, setController] = useState(controllerData[0]);
	const [id, setId] = useState(0);

	let menuList = [
		{ title: globalAny.language.view, disabled: false },
		{ title: globalAny.language.details, disabled: carActivity === CarActivity.INMOTION },
		{ title: globalAny.language.extras, disabled: noVamData ? true : carActivity === CarActivity.INMOTION },
	];

	let menuListPreview = [
		{ title: globalAny.language.view, disabled: false },
		{ title: globalAny.language.details, disabled: carActivity === CarActivity.INMOTION },
	];
	const [menuItem, setMenuItem] = useState(menuList);

	const redeemCredit = () => {
		let credit = parseInt(creditCost);
		if (credit > 1) {
			return globalAny.language.redeem_for_more_than_one.replace("%c", creditCost);
		}
		return globalAny.language.redeem_credit;
	};

	const redeemSuccess = () => {
		let credit = parseInt(creditCost);
		if (credit > 1) {
			return globalAny.language.redeem_success_for_more_than_one.replace("%c", creditCost);
		}
		return globalAny.language.redeem_success;
	};

	const wording = {
		redeemContent: globalAny.language.redeem_content,
		modalFooter: `${globalAny.language.available_audio_language} English, Spanish, French, German, Italian<br> ${globalAny.language.available_closed_caption_language} English, Spanish, French, German, Italian`,
		redeemCredit: redeemCredit(),
		redeemSuccess: redeemSuccess(),
		redeemLimit: globalAny.language.redeem_limit,
		purchaseRentContent: globalAny.language.purchase_rent_content,
		purchaseOnlyContent: globalAny.language.purchase_only_content,
		rentOnlyContent: globalAny.language.rent_only_content,
		rent: globalAny.language.rent_for,
		rentExpiry: globalAny.language.rent_expiry,
		purchase: globalAny.language.purchase_for,
		movieNotAvailable: globalAny.language.movie_not_available_user,
		errorPurchase: globalAny.language.error_purchase,
		cancel: globalAny.language.cancel,
		concurrentLimit: globalAny.language.concurrent_limit,
		processing: globalAny.language.processing,
		legalText: globalAny.language.legal_terms_text,
	};

	//#region Function
	/**
	 * Fetch price of current ProductId
	 * Note: currency symbol is not yet dynamic.
	 */
	const fetchPrice = async () => {
		const currentProductPrice: any = await productPrice(parentProductId);
		const [productPurchasePrice] =
			currentProductPrice?.productTierDetails?.filter((product: any) => product.transactionTypeId === PurchaseTransactionType.Purchase) ?? [];
		const [productRentPrice] =
			currentProductPrice?.productTierDetails?.filter((product: any) => product.transactionTypeId === PurchaseTransactionType.Rent) ?? [];
		const rentCurrencyCode = productRentPrice?.currency;
		const purchaseCurrencyCode = productPurchasePrice?.currency;
		const currency = getCurrencySymbol(rentCurrencyCode) ?? getCurrencySymbol(purchaseCurrencyCode);
		setCurrencySymbol(currency);
		setTextPurchase(`${wording.purchase}${currency}${productPurchasePrice?.price}`);
		setPurchasePrice(productPurchasePrice?.price);

		if (productRentPrice) {
			setRentPrice(productRentPrice?.price);
			setTextRent(`${wording.rent}${currency}${productRentPrice?.price}`);
			setHasRent(true);
		}
	};

	const getVam = (result: any) => {
		if (result?.vam) {
			setVamData(result?.vam);
			setNoVamData(false);

			const newMenuItem = menuItem.map((item) => {
				if (item.title === globalAny.language.extras) {
					return { ...item, disabled: false };
				}
				return item;
			});
			setMenuItem(newMenuItem);
			if (result?.vam?.products?.length === 0) {
				const newMenuItem = menuItem.map((item) => {
					if (item.title === globalAny.language.extras) {
						return { ...item, disabled: true };
					}
					return item;
				});
				setMenuItem(newMenuItem);
				setNoVamData(true);
			}
			return;
		}

		if (vamData) return;

		const newMenuItem = menuItem.map((item) => {
			if (item.title === globalAny.language.extras) {
				return { ...item, disabled: true };
			}
			return item;
		});

		setMenuItem(newMenuItem);
		setNoVamData(true);
	};

	const onPreview = (metadata: any) => {
		fetchAudioLanguages();
		setMetadata(metadata);
		const crewMember = filterRole(metadata?.crewMembers, "Director") ?? filterRole(metadata?.crew, "Director");
		setDirector(crewMember);

		const portraitImage = metadata.images?.filter((val: any) => val.width === 600 && val.height === 900)?.map((val: any) => val.url)[0];
		setPackshot(portraitImage);
		setRatingReason(metadataTextSeparator(metadata));
		setOwnProduct(false);
		setIsRedeem(false);
		setIsPurchase(false);
		setAvailabilityRent(false);
		setAvailabilityPurchase(false);
		setAvailabilityRedeem(false);
		setIsLoadingButton(false);
		setSelectedProductRedeemed({ owned: true });
		getVam({});
		setIsCompleteData(true);
	};

	const getMetadata = async (result: any) => {
		if (result?.metadata) {
			if (preview) {
				onPreview(result?.metadata);
				return;
			}

			const crewMember = filterRole(result?.metadata?.crewMembers, "Director") ?? filterRole(result?.metadata?.crew, "Director");
			setDirector(crewMember);

			const portraitImage = result?.metadata.images
				?.filter((val: any) => val.width === 600 && val.height === 900)
				?.map((val: any) => val.url)[0];
			setPackshot(portraitImage);
			setRatingReason(metadataTextSeparator(result?.metadata));
			setMetadata(result?.metadata);

			await progressVideo(result?.metadata.duration);
		}
	};

	const getAudios = (result: any, availability: any, owned: any) => {
		if (result?.ownedstatus) {
			fetchAudioLanguages(availability, owned);
			return;
		}
		fetchAudioLanguages(availability);
	};

	const getOwnedStatus = async (result: any, availability: any) => {
		if (result?.ownedstatus) {
			const owned = await result?.ownedstatus?.filter((val: any) => val.owned === true).sort((a: any, b: any) => a - b);

			if (owned?.length === 0) {
				setSelectedProductRedeemed(result?.ownedstatus);
				setProgressBar(0);
			} else {
				setOwnedTransaction(owned.find((val: any) => val.owned === true));
				const hasRented = owned?.find((val: any) => val.transactionType === TRANSACTION_TYPES.TVOD && val.owned === true);
				const hasPurchased = owned?.find((val: any) => val.transactionType !== TRANSACTION_TYPES.TVOD && val.owned === true);
				setSelectedProductRedeemed(result?.ownedstatus);
				setOwnProduct(true);

				if (!hasPurchased && hasRented) {
					const videoQuality = getVideoQualityByDeviceHeight(dimensions.screen.height);
					const expiryDetails: any = await getPlaybackWindow(parentProductId, TRANSACTION_TYPES.TVOD, videoQuality);
					expiryDetails?.utcExpiryDate ? setExpiryDate(expiryDetails) : setIsRented(false);
				}
			}
		}
	};

	const filterRole = (data: any, role: string) => {
		const newRole = data?.filter((val: any) => val.role === role).map((val: any) => val.name);
		return newRole;
	};

	const checkNetwork = async () => {
		const isConnected = await onCheckingNetwork();

		if (!isConnected || isConnected === undefined) {
			setVisible(true);
			setToastMessage(globalAny.language.network_connection_lost);
			setLabelText("");
		}
	};

	const onAvailability = async (result: any, availability: any) => {
		const hasEST = availability?.transactionTypes?.indexOf(TRANSACTION_TYPES.EST) > -1;
		const hasTVOD = availability?.transactionTypes?.indexOf(TRANSACTION_TYPES.TVOD) > -1;
		const isFree = availability?.transactionTypes?.indexOf(TRANSACTION_TYPES.FVOD) > -1;
		const availableCreditCost = availability?.creditCost ?? 1;

		setCreditCost(availableCreditCost);

		const userCredits: any = await accountCredits();
		const hasAvailableCredit = userCredits.creditsAvailable > 0;
		let hasRedeemed: boolean = false,
			hasRented: boolean = false,
			hasPurchased: boolean = false,
			hasSubscribed: boolean = false;

		setHasCredit(hasAvailableCredit);
		setAvailabilityRedeem(availability?.isRedeemable);

		const isOwned = () => {
			return isFree || hasSubscribed || hasRedeemed || hasRented || hasPurchased;
		};

		if (result?.ownedstatus) {
			const owned = result?.ownedstatus?.filter((val: any) => val.owned === true);
			hasSubscribed = owned?.find((val: any) => val.transactionType === TRANSACTION_TYPES.SVOD && val.owned);
			hasRedeemed = owned?.find((val: any) => val.transactionType === TRANSACTION_TYPES.EST && val.owned);
			hasRented = owned?.find((val: any) => val.transactionType === TRANSACTION_TYPES.TVOD && val.owned);
			hasPurchased = owned?.find((val: any) => val.transactionType === TRANSACTION_TYPES.EST && val.owned);
		}

		if (isOwned()) {
			setOwnProduct(true);
			if (hasRedeemed || hasPurchased || hasSubscribed) {
				setAvailabilityRedeem(false);
				setIsRedeem(true);
				setIsPurchase(true);
				setIsRented(false);
				return;
			}

			if (hasRented) {
				setIsRented(true);
			}

			return;
		}

		if (availability?.releaseType === 2) {
			setAvailabilityRent(hasTVOD);
			setAvailabilityPurchase(hasEST);
			return;
		}

		if (availability?.releaseType === 0 || !availability?.releaseType) {
			if (hasAvailableCredit) {
				setAvailabilityRent(hasTVOD);
				setAvailabilityPurchase(false);
				return;
			}

			setAvailabilityRent(hasTVOD);
			setAvailabilityPurchase(hasEST);
		}
	};

	const progressVideo = async (duration: any) => {
		try {
			const result: any = await getProgressVideo(parentProductId);
			if (result?.responseCode === responseOk) {
				const streamProgress: any = (Number(result?.streamProgress) / (convertDuration(duration) * 1000)) * 100 || 0;
				setStreamProgress(result?.streamProgress);
				setProgressBar(streamProgress);
			}
		} catch {}
	};

	const getImages = async (metadata: any) => {
		const result = metadata;
		let TBG = result?.images.tbg;

		try {
			// @ts-ignore
			let imageToUse = TBG;
			if (imageToUse) {
				setBackgroundImage(`${imageToUse.imageUrl}?width=1600&disablewebp=false`);
			} else {
				setBackgroundImage(NO_IMAGE_RETURNED);
			}
		} catch (err) {
			AppLogger.log(err);
		}
	};

	const exitPreview = () => {
		navigation.navigate(routeLogin);
	};

	const onPlay = async () => {
		await checkNetwork();
		AppLogger.log("ownedTransaction", ownedTransaction);
		const streamLimit: any = await getConcurrency(ownedTransaction?.transactionType ?? 1);

		if (!streamLimit?.globalStreams || streamLimit?.streamsAvailable === 0) {
			setType(ComponentTypeEnum.Secondary);
			setToastMessage(wording.concurrentLimit);
			setLabelText(globalAny.language.ok);
			setVisible(true);
			return;
		}

		if (isPlayerLoading) return;
		setIsPlayerLoading(true);

		const playSessionId = uuidv4();
		setStartPlaying(true);
		setPlaySessionId(playSessionId);
		localStorage.setItem(AsyncStorageKeys.playSessionId, playSessionId);
		await postConcurrency(ownedTransaction?.transactionType ?? 1);
		navigation.navigate(routePlayer, { parentProductId, resumeProgress: streamProgress ?? 0 });
	};

	const onTrailer = async () => {
		await checkNetwork();

		const trailer: any = await getTrailer(parentProductId);
		const streamUrl = trailer.url;

		navigation.navigate(routeTrailer, preview ? { parentProductId, streamUrl, preview: true } : { parentProductId, streamUrl });
	};

	const onAssignScreen = () => {
		if (channelData.length > 1) {
			setVamDetails(null);
			navigation.navigate(routeScreenManager, { location: Pages.assignScreen, parentProductId: parentProductId, redirectTo: direction.main });
			return;
		}
		setType(ComponentTypeEnum.Processing);
		setVisible(true);
		setToastMessage(globalAny.language.assign_single_screen_message);
		setLabelText("");
	};

	const onClickRedeemMovies = () => {
		setShowRedeemModal(true);
	};

	const onClickPurchaseOptions = async () => {
		try {
			const allowUntil = await AsyncStorage.getItem(AsyncStorageKeys.allowUntil);
			const currentTime = new Date().getTime();

			if (allowUntil && parseInt(allowUntil) > currentTime) {
				setToastMessage(globalAny.language.please_try_again_after);
				setType(ComponentTypeEnum.Secondary);
				setVisible(true);
				return;
			}

			setShowPurchaseModal(true);
		} catch (error) {
			AppLogger.error(error);
		}
	};

	const onClose = () => {
		navigation.navigate(preview ? routeLogin : routeHome);
		setNavigateEvent("");
		setSelectedTabs(0);
	};

	const redeemError = () => {
		if (mistakeCount < 3) {
			setType(ComponentTypeEnum.Secondary);
			setShowRedeemModal(false);
			setVisible(true);
			setToastMessage(wording.errorPurchase);
			setLabelText(globalAny.language.label_retry);
			setMistakeCount(mistakeCount + 1);
			return;
		}
		setLabelText("");
		setType(ComponentTypeEnum.Secondary);
		const allowUntil = new Date().setMinutes(new Date().getMinutes() + 1);
		AsyncStorage.setItem(AsyncStorageKeys.allowUntil, allowUntil.toString());
		setToastMessage(wording.redeemLimit);
		setVisible(true);
		setShowRedeemModal(false);
	};

	const onRedeemMovies = async () => {
		setIsProcessing(true);
		const result: any = await redeemProductV8(parentProductId, 6);

		if (result?.responseCode === 10006) {
			recordAnalytics(EventType.Redeemed, { product_id: parentProductId, product_title: metadata?.title });

			setIsRedeem(true);
			setAvailabilityRedeem(false);

			const newVamDetails = vamData.products?.map((item: any) => {
				return { ...item, vamStatus: 3 };
			});
			setVamData(newVamDetails);

			const promiseResult = await Promise.allSettled([accountCredits(), accountCreditsExpiration(), purchaseHistory()]);
			// @ts-ignore
			const [userCreditsData, userCreditsExpirationData, purchaseHistoryData] = promiseResult.map((i) => i.value);

			CacheStorageUtils.setCacheItem(AsyncStorageKeys.accountDetails, [userCreditsData, userCreditsExpirationData, purchaseHistoryData], true);
			setIsRented(false);
			setIsProcessing(false);
			setShowRedeemModal(false);
			setOwnProduct(true);
			setShowRedeemModal(false);
			setType(ComponentTypeEnum.Primary);
			setToastMessage(wording.redeemSuccess.replace("%d", userCreditsData?.creditsAvailable));
			setLabelText("VIEW DETAILS");
			setVisible(true);
			init();
			return;
		}

		setIsProcessing(false);
		redeemError();
	};

	const onPurchaseMovie = () => {
		if (isMobilePaymentEnabled()) {
			setShowPurchaseModal(false);
			navigation.navigate(routeMobilePayment, { parentProductId, paymentType: "purchase" });
			return;
		}
		setIsDisabled(true);
		setSelectedTabs(0);
		setShowPurchaseModal(false);
		navigationPayment.navigate(routePayment, { parentProductId, paymentType: "purchase" });
		setTimeout(() => {
			setIsDisabled(false);
		}, 1500);
	};

	const onRentMovie = () => {
		if (isMobilePaymentEnabled()) {
			setShowPurchaseModal(false);
			navigation.navigate(routeMobilePayment, { parentProductId, paymentType: "rent" });
			return;
		}
		setIsDisabled(true);
		setSelectedTabs(0);
		setShowPurchaseModal(false);
		navigationPayment.navigate(routePayment, { parentProductId, paymentType: "rent" });
		setTimeout(() => {
			setIsDisabled(false);
		}, 1500);
	};

	const navigateWithEvent = () => {
		if (navigateEvent === Pages.page) {
			navigation.navigate(routePage, { uniqueId });
			return;
		}
		if (navigateEvent === Pages.search) {
			if (lastSearchData.length > 0) {
				navigation.navigate(routeSearchScreen);
			} else {
				setSelectedTabs(0);
				navigation.navigate(routeSearchScreen);
				setNavigateEvent("");
			}
			return;
		}
		if (navigateEvent === Pages.transactions) {
			setSelectedTabs(0);
			navigation.navigate(routeDataManagementSettings, { location: Pages.transactions });
			setNavigateEvent("");
			return;
		}
		if (navigateEvent === Pages.library) {
			setSelectedTabs(0);
			navigation.navigate(routeMyLibrary);
			setNavigateEvent("");
			return;
		}
		if (navigateEvent === Pages.homeAggregatePage) {
			navigation.navigate(routeAggregatePage, { id: aggregatePageId.id, location: aggregatePageId.location });
			setSelectedTabs(0);
			return;
		}
		setSelectedTabs(0);
		navigation.navigate(routeNewCuration);
		setNavigateEvent("");
	};

	const onCheckReload = () => {
		if (streamProgress >= 0 && ownProduct && startPlaying) {
			setIsRenderHome(true);
			return;
		}
		setStartPlaying(false);
	};

	const back = () => {
		const previousRoute = getPreviousRouteName(navigation);
		const isPreviousRouteScreenManager = previousRoute === routeVamScreenManager || previousRoute === routeScreenManager;
		const isPreviousRoutePlayer = previousRoute === routePlayer || previousRoute === routeVamPlayer || !previousRoute;
		setVisible(false);
		setIsSuccess(false, false);
		setSelectedTabs(0);
		onCheckReload();
		setIsExtras(false);
		if (navigation.canGoBack() && !isPreviousRoutePlayer && !isPreviousRouteScreenManager) {
			navigation.goBack();
			return;
		}

		if (preview) {
			navigation.navigate(routePage, { uniqueId: "preview" });
			return;
		}

		if (!navigateEvent || navigateEvent === Pages.main) {
			setSelectedTabs(0);
			setNavigateEvent("");
			navigation.navigate(routeHome);
			return;
		}

		navigateWithEvent();
	};

	const dismissRedeemModal = () => {
		setShowRedeemModal(false);
	};

	const dismissPurchaseModal = () => {
		setShowPurchaseModal(false);
	};

	const onPressToast = (command: string) => {
		if (command === globalAny.language.label_view_details) {
			checkCacheData();
		} else if (command === globalAny.language.label_retry) {
			setVisible(true);
			onRedeemMovies();
		}
	};

	const checkCacheData = async () => {
		const transactionHistory: any = await purchaseHistory();
		if (transactionHistory.responseCode === responseOk) {
			navigation.navigate(routeLegalsScreen, { location: Pages.transactions });
			return;
		}

		setType(ComponentTypeEnum.Secondary);
		setToastMessage(globalAny.language.no_transaction_history);
		setVisible(true);
	};

	const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }: any) => {
		const paddingBottom = 100;
		return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingBottom;
	};

	const calculateGridItemsByWindowWidth = (width: any) => {
		if (width <= 619) return 3;
		if (isNarrow) return 5;
		return 4;
	};

	const onLazyLoading = () => {
		if (next >= vamData.products.length) return;

		setExtraLoader(true);
		setTimeout(() => {
			setExtraLoader(false);
			setNext(next + gridSize);
		}, 1000);
	};

	const onController = () => {
		if (id === 0) {
			setController(controllerData[1]);
			setId(1);
			return;
		}
		setController(controllerData[0]);
		setId(0);
	};

	const fetchAudioLanguages = async (availability?: any, ownedStatus?: any) => {
		let owned;
		if (ownedStatus?.length) {
			owned = ownedStatus[0];
		}

		const [availabilityTransactionType] = availability?.transactionTypes ?? [TRANSACTION_TYPES.EST];
		const availableLanguages: any = await getAvailableAudioLanguages(
			parentProductId,
			1080,
			owned?.transactionType ?? availabilityTransactionType,
			owned ? owned?.countryId : "",
		);
		if (availableLanguages.responseCode === responseOk) {
			const audio = convertToLanguage(availableLanguages.audioLanguages);
			const subtitle = convertToLanguage(availableLanguages.subtitleLanguages);
			setAudioLang(audio);
			setSubtitleLang(subtitle);
			setMovieAvailableLang(
				`${globalAny.language.available_audio_language} ${audio}<br>${globalAny.language.available_closed_caption_language} ${subtitle}`,
			);
		}
	};

	const checkAvailableTrailer = async () => {
		const trailer: any = await getTrailer(parentProductId);
		const trailerUrl = trailer.url;
		if (trailerUrl && (!isCoPassenger() || isVersionValidForTrailer())) {
			setIsTrailer(true);
			return;
		}
		setIsTrailer(false);
	};

	const getModalMessage = () => {
		if ((availabilityPurchase && availabilityRent) || (isRented && isPurchase)) return wording.purchaseRentContent;

		if ((!hasCredit && isRented) || availabilityPurchase) return wording.purchaseOnlyContent;

		if (availabilityRent || isRented) return wording.rentOnlyContent;

		return "";
	};

	const getModalFooter = () => {
		if (isToggleSKLegals) return `${movieAvailableLang}\n\n${globalAny.language.sk_legal_terms_text}`;

		return movieAvailableLang;
	};

	const onPressTermsAndService = () => {
		navigation.navigate(routeLegalsScreen, { location: Pages.legalTerms });
	};

	const onCheckTitle = () => {
		return renderHeaderTitle(metadata?.title);
	};

	const onCycleComplete = () => {
		setPauseMarquee(true);
		setTimeout(() => setPauseMarquee(false), 3000);
	};

	const fetchData = async (result: any) => {
		if (result?.metadata?.responseCode === 40058 || isNaN(parentProductId)) {
			setVisible(true);
			setToastMessage(wording.movieNotAvailable);
			setTimeout(() => {
				setSelectedTabs(0);
				location.replace("/home");
			}, 3000);
			return;
		}

		setIsLoadingButton(true);

		if (result?.images) {
			await getImages(result);
		}

		if (preview) {
			getMetadata(result);
			setIsLoadingButton(false);
			return;
		}

		await fetchPrice();
		const availability: any = await getAvailability(parentProductId);
		const owned = result?.ownedstatus?.filter((val: any) => val.owned === true).sort((a: any, b: any) => a - b);
		getAudios(result, availability, owned);
		getMetadata(result);
		await getOwnedStatus(result, availability);
		await onAvailability(result, availability);
		getVam(result);
		setIsCompleteData(true);
		setIsLoadingButton(false);
	};

	const init = async () => {
		try {
			setIsCompleteData(false);
			fetchLegals(AsyncStorageKeys.legals);

			const result = preview ? await metadataContentPreview(parentProductId) : await metadataContent(parentProductId);
			fetchData(result);
		} catch (err) {
			AppLogger.log(err);
		}
	};

	const isMobilePaymentEnabled = () => {
		if (!isEnableMobilePayment) return false;

		if (mobilePaymentTerritories && mobilePaymentTerritories.length === 0) return true;
		else return mobilePaymentTerritories.find((region: string | null) => region === localStorage.getItem(AsyncStorageKeys.RegionOverride));
	};

	/**
	 * Reloads and resets the necessary app state after regaining connection.
	 *
	 * - Clears existing metadata
	 * - Resets the home render state
	 * - Re-initializes app data
	 * - Checks for available trailers
	 *
	 * This function is triggered once after reconnecting to ensure the app
	 * returns to a consistent and updated state.
	 */
	const loadData = () => {
		setIsExtras(false);
		setMetadata(undefined);
		setIsRenderHome(false);
		init();
		checkAvailableTrailer();
	};
	//#endregion

	//#region useEffect
	useEffect(() => {
		if (!mqttDevices.length) {
			return;
		}

		setChannelData(mqttDevices);
	}, [mqttDevices]);

	useFocusEffect(
		useCallback(() => {
			if (!isExtras) {
				loadData();
			}
		}, [parentProductId, isExtras]),
	);

	useFocusEffect(
		useCallback(() => {
			if (parentProductId && metadata?.title)
				recordAnalytics(EventType.ScreenView, {
					screen_name: Pages.titleDetailsPage,
					product_id: parentProductId,
					product_title: metadata?.title,
				});
		}, [parentProductId, metadata]),
	);

	useEffect(() => {
		setShowCarToast(carActivity === CarActivity.INMOTION);
		setMenuItem(menuList);
	}, [carActivity]);

	useEffect(() => {
		if (preview) {
			setMenuItem(menuListPreview);
			return;
		}
		setMenuItem(menuList);
	}, [preview]);

	useEffect(() => {
		if (isSuccess.result) {
			setType(ComponentTypeEnum.Primary);
			setLabelText(globalAny.language.label_view_details);

			if (isSuccess.isRented) {
				setToastMessage(globalAny.language.movie_rented);
			} else {
				setToastMessage(globalAny.language.movie_purchased);
			}

			setVisible(true);
			setTimeout(() => {
				setIsSuccess(false, false);
			}, 6000);
		} else {
			setVisible(false);
		}
	}, [isSuccess]);

	/**
	 * useEffect to detect resize on window
	 */
	useEffect(() => {
		const resizeHandler = () => {
			setWindowWidth(Dimensions.get("window").width);
			setGridSize(calculateGridItemsByWindowWidth(Dimensions.get("window").width));
		};
		resizeHandler();

		window.addEventListener("resize", resizeHandler);
		return () => window.removeEventListener("resize", resizeHandler);
	}, [windowWidth]);

	/**
	 * Manages data reloading when the app regains an internet connection.
	 *
	 * - When the device goes offline (`isOffline` becomes true), a flag is set
	 *   so that data can be reloaded once the connection is restored, and the
	 *   "online" indicator is hidden.
	 *
	 * - When the device comes back online (`isOnline` is true) **and** the flag is set,
	 *   the flag is reset, the "online" indicator is shown, and `loadData()` is
	 *   executed **once only**.
	 */
	useEffect(() => {
		if (isOffline) {
			hasReloaded.current = true;
			setShowOnline(false);
		}

		if (isOnline && hasReloaded.current) {
			hasReloaded.current = false;
			setShowOnline(true);
			loadData();
		}
	}, [isOnline, isOffline]);

	useEffect(() => {
		if (selectedTabs === 2) {
			setTimeout(() => {
				setIsExtrasLoading(false);
			}, 1000);
		}
	}, [selectedTabs, parentProductId]);

	//#endregion

	const renderHeaderTitle = (title: any) => {
		if (!title || !isCompleteData) return;
		const titleLength: any = metadata?.title.length;
		const longTitle = titleLength > 50;
		return (
			/* @ts-ignores */
			<Text>
				{longTitle ? (
					<Marquee play={!pauseMarquee} speed={50} direction={"left"} autoFill={true} delay={1} onCycleComplete={onCycleComplete}>
						<span style={{ marginRight: "25rem" }}>{title} &nbsp;&nbsp;&nbsp;</span>
					</Marquee>
				) : (
					title
				)}
			</Text>
		);
	};

	const renderBackgroundNarrow = () => {
		if (backgroundImage && isNarrow) {
			return (
				//@ts-ignores
				<StyledMainNarrow>
					<StyledMaskGroupNarrow bgImage={backgroundImage} />
					{/* <GradientLeftSide isNarrow={isNarrow} /> */}
				</StyledMainNarrow>
			);
		}

		return <></>;
	};

	const renderPackshot = () => {
		if (isNarrow && !backgroundImage) {
			return (
				//@ts-ignore
				<StyledPackshotNarrow>
					<Image source={{ uri: packshot }} width={"100%"} height={"100%"} style={{ borderRadius: "0.75rem", position: "absolute" }} />
				</StyledPackshotNarrow>
			);
		}

		return (
			//@ts-ignore
			<StyledImage>
				{!backgroundImage && (
					<>
						{/* @ts-ignores */}
						<StyledLoading>
							<ImgProgressBar />
						</StyledLoading>
						{/* @ts-ignores */}
						<StyledPackshot>
							<Image source={{ uri: packshot }} width={"100%"} height={"100%"} style={{ borderRadius: 16, position: "absolute" }} />
						</StyledPackshot>
					</>
				)}
			</StyledImage>
		);
	};

	return (
		<SafeAreaView style={{ flex: 1 }}>
			{/* @ts-ignores */}
			<StyledContainerTdp>
				<TopAppBar
					leftIcon={closeIcon}
					leftTitleIcon={backIcon}
					leftIconWidth={92}
					screenTitle={onCheckTitle()}
					onPressLeftIcon={onClose}
					onPressLeftTitleIcon={back}
					isNarrow={isNarrow}
				/>

				<ScrollView scrollEnabled={!isNarrow}>
					{/* @ts-ignores */}
					<TabsContainer isNarrow={isNarrow}>
						{!isCompleteData && <TitleDetailsLoader />}
						{metadata?.title && (
							<TabsView
								isTDP={true}
								tabsToRender={menuItem}
								paddingLeft={122}
								disabled={!(metadata && selectedProductRedeemed)}
								controller={controller}
								channelData={channelData}
								onController={onController}
							>
								{/* @ts-ignores */}
								<StyledTabsContainer isNarrow={isNarrow}>
									{renderBackgroundNarrow()}
									{/* @ts-ignores */}
									<StyledMain bgImage={backgroundImage} isNarrow={isNarrow}>
										{!isNarrow && <GradientLeftSide />}
										{/* @ts-ignores */}
										<StyledContainerColumn isNarrow={isNarrow}>
											<ViewDetails
												metadata={metadata}
												genres={metadata?.genres}
												ratingReason={ratingReason}
												rating={metadata?.rating}
												synopsis={metadata?.synopsis}
												parentProductId={parentProductId}
												streamProgress={progressBar}
												onPlay={() => onPlay()}
												onTrailer={() => onTrailer()}
												onAssignScreen={() => onAssignScreen()}
												onRedeemMovie={() => onClickRedeemMovies()}
												onPurchase={() => onClickPurchaseOptions()}
												hasCredit={hasCredit}
												isRented={isRented}
												isRedeem={isRedeem}
												isPurchase={isPurchase}
												expiryDate={expiryDate}
												availabilityRedeem={availabilityRedeem}
												availabilityPurchase={(!hasCredit && isRented) || availabilityPurchase}
												availabilityRent={!availabilityRent || isRented ? false : availabilityRent}
												purchaseText={textPurchase}
												rentText={textRent}
												isTrailer={isTrailer}
												isLoadingButton={isLoadingButton}
												isPreview={preview}
												redeemCredit={wording.redeemCredit}
												isNarrow={isNarrow}
											/>
											{/* @ts-ignores */}
											{renderPackshot()}
										</StyledContainerColumn>
										{!isNarrow && <BlurFooter />}
									</StyledMain>
								</StyledTabsContainer>
								{/* @ts-ignores */}
								<StyledTabsContainer isNarrow={isNarrow}>
									<ScrollView scrollEnabled={true}>
										<Details
											genres={metadata?.genres}
											ratingReason={ratingReason}
											rating={metadata?.rating}
											cast={metadata?.cast}
											synopsis={metadata?.synopsis}
											parentProductId={parentProductId}
											copyright={metadata?.copyright}
											audioLanguage={metadata?.language}
											director={director}
											audioLang={audioLang}
											subtitle={subtitleLang}
											isPreview={preview}
										/>
									</ScrollView>
								</StyledTabsContainer>
								{/* @ts-ignores */}
								<StyledTabsContainer isNarrow={isNarrow}>
									<ScrollView
										onScroll={({ nativeEvent }) => {
											if (isCloseToBottom(nativeEvent) && selectedTabs === 2 && !extraLoader) {
												onLazyLoading();
											}
										}}
										scrollEventThrottle={400}
										scrollEnabled={true}
									>
										<Extras
											data={vamData?.products?.slice(0, next)}
											parentProductId={parentProductId}
											redeem={ownProduct}
											ribbonTitle={globalAny.language.assign_single_screen_message}
											id={id}
											extraLoader={extraLoader}
											gridSize={gridSize}
											isExtrasLoading={isExtrasLoading}
										/>
									</ScrollView>
								</StyledTabsContainer>
							</TabsView>
						)}
					</TabsContainer>
				</ScrollView>
				{!isNarrow && <BlurFooter />}
				{channelData && selectedTabs === 2 && isToggleMQTT && !isNarrow && (
					<ControllerContent
						data={controller}
						isTitle={channelData?.length <= 1}
						ribbonTitle={globalAny.language.assign_single_screen_message}
						onPress={() => onController()}
					/>
				)}
			</StyledContainerTdp>

			{showRedeemModal && (
				<CustomizeDialogBox
					Header={metadata?.title}
					Body={wording.redeemContent}
					Footer={movieAvailableLang}
					ButtonTextLeft={wording.redeemCredit}
					ButtonTextRight={isProcessing ? wording.processing : wording.cancel}
					legalTextTitle={wording.legalText}
					legalButtonTextTitle={globalAny.language.terms_of_service}
					SingleButton={!!isProcessing}
					CloseButton={false}
					isLegalTerm={isDefaultTerritory}
					Width={680}
					Height={"auto"}
					TypeButtonColorLeft={ComponentTypeEnum.Tertiary}
					TypeButtonColorRight={isProcessing ? ComponentTypeEnum.Tertiary : ComponentTypeEnum.Secondary}
					isProcessing={!!isProcessing}
					onPressRight={isProcessing ? () => {} : dismissRedeemModal}
					onPressTermsAndService={() => onPressTermsAndService()}
					onPressLeft={onRedeemMovies}
				/>
			)}

			{showPurchaseModal && (
				<CustomizeDialogBox
					Header={metadata?.title}
					Body={getModalMessage()}
					Footer={getModalFooter()}
					ButtonTextLeft={textPurchase}
					ButtonTextMiddle={hasRent ? textRent : textPurchase}
					ButtonTextRight={isProcessing ? wording.processing : wording.cancel}
					ButtonSubTextLeft={wording.rentExpiry}
					legalTextTitle={wording.legalText}
					legalButtonTextTitle={globalAny.language.terms_of_service}
					hasSubTextLeft={hasRent}
					SingleButton={!!isProcessing}
					isProcessing={!!isProcessing}
					HasMiddleButton={!availabilityRent || isRented ? false : availabilityRent}
					HasFirstButton={(!hasCredit && isRented) || availabilityPurchase || isRented}
					isTDP={true}
					isLegalTerm={isDefaultTerritory}
					CloseButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorLeft={ComponentTypeEnum.Primary}
					TypeButtonColorMiddle={ComponentTypeEnum.Primary}
					TypeButtonColorRight={ComponentTypeEnum.Secondary}
					onPressLeft={onPurchaseMovie}
					onPressMiddle={hasRent ? onRentMovie : onPurchaseMovie}
					onPressRight={isProcessing ? () => {} : dismissPurchaseModal}
					onPressTermsAndService={() => onPressTermsAndService()}
					disableButton={isDisabled}
				/>
			)}
			<Toast
				visible={visible}
				text={toastMessage}
				label={labelText}
				type={type}
				onDismissSnackBar={onDismissSnackBar}
				onPress={() => onPressToast(labelText)}
			/>

			<CarActivityDialog
				title={globalAny.language.car_in_motion_title}
				body={globalAny.language.car_in_motion_body}
				buttonText={globalAny.language.car_in_motion_back_to_movie}
				onPress={() => setSelectedTabs(0)}
				show={carActivity === CarActivity.INMOTION && selectedTabs === 1}
			/>

			<Toast
				visible={showCarToast && selectedTabs !== 1}
				text={globalAny.language.car_in_motion_body}
				label={labelText}
				type={type}
				onDismissSnackBar={() => setShowCarToast(false)}
				onPress={() => onPressToast(labelText)}
			/>

			<Toast
				visible={showOnline}
				text={globalAny.language.connection_restored}
				label={""}
				type={ComponentTypeEnum.Primary}
				onDismissSnackBar={() => setShowOnline(false)}
				onPress={() => {}}
			/>

			{preview && metadata?.title ? <ExitPreviewButton isNarrow={isNarrow} isPreview={preview} onPress={() => exitPreview()} /> : <></>}
		</SafeAreaView>
	);
};

export default NewTitleDetails;
